/** Shown instead of the app when required PUBLIC_* settings are missing from apps/web/.env. */
export function ConfigErrorPage({ missing }: { missing: string[] }) {
  return (
    <main className="flex flex-col gap-4 min-h-screen items-center justify-center bg-surface-canvas text-text-primary">
      <h1 className="text-lg">Sage isn't configured</h1>
      <p className="text-text-secondary">Set these in apps/web/.env, then restart the dev server:</p>
      <ul className="font-mono text-sm">
        {missing.map((key) => (
          <li key={key}>{key}</li>
        ))}
      </ul>
    </main>
  );
}
